<template>
    <div :class="[$style.info_block, isDesktopFooter && $style.info_block_desktop_footer]">
        <img
            v-if="!props.unavailable && !props.disabledIcon"
            :class="[
                'sqrcl',
                $style.image,
                props.game ? $style.visible : $style.hidden,
                isDesktopFooter && $style.image_desktop_footer,
                props.limitedAvailability && $style.darken_filter,
            ]"
            :src="props.game?.icon"
            :alt="props.game?.title"
        />
        <div
            v-else
            :class="[$style.image, $style.unavailable_image, isDesktopFooter && $style.image_desktop_footer]"
        />
        <GameInfoTitle
            :game="props.game"
            :category="props.category"
            :placement="props.placement"
            :unavailable="props.unavailable"
            :limitedAvailability="props.limitedAvailability"
        />
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { APIGameType } from '@/types'

import GameInfoTitle from './GameInfoTitle.vue'

const props = defineProps<{
    game?: APIGameType
    category?: string
    placement?: 'desktop_footer' | 'init_screen' | 'mobile_game_container'
    unavailable?: boolean
    disabledIcon?: boolean
    limitedAvailability?: boolean
}>()

const isDesktopFooter = computed(() => props.placement === 'desktop_footer')
</script>

<style module>
.visible {
    opacity: 1;
}

.hidden {
    opacity: 0;
}

.info_block {
    overflow: hidden;
    display: flex;
    min-width: 0;
    max-width: 100%;
    height: 48px;
    gap: 8px;
}

.image {
    width: 48px;
    height: 48px;
    object-fit: cover;
    --sqrcl: 24px;
}

.info_block_desktop_footer {
    height: 40px;
}

.image_desktop_footer {
    width: 40px;
    height: 40px;
    --sqrcl: 16px;
}

.darken_filter {
    filter: grayscale(100%) brightness(65%);
}

.unavailable_image {
    background-color: var(--white-16);
}
</style>
